// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_WUo","cls2":"AuthorHeader-cls2_DRp AuthorHeader-cls1_WUo"};